
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
name: "mat-unit",
directives: {
TransferDom
},
components:{
PopupHeader,
Popup
},
data() {
return {
refresh:true,
wrapperHeight: 0,
allLoaded: false,
config: {
title: '物料单位转化',
url: 'api/mat-unit/page'
},
list: []
}
},
methods: {
getList(e,met,bol){
this.$nextTick(()=>{
if(bol){
this.list = this.list.concat(e);
}else{
this.list = e;
}
if(met === 'top'){
this.$refs.loadmore.onTopLoaded();
}
if(met === 'bottom'){
this.$refs.loadmore.onBottomLoaded();
}
})
},
init: function () {

this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
},
loadTop(){
this.$refs.header.getlist(true);
},
loadBottom(){
this.$refs.header.getMore();
}
},
mounted() {
if(this.$route.query.matId){
this.config = {
title: '物料单位转化',
url: 'api/mat-unit/page',
property:'id',
fixRules: {
rules:[{
field:'material.id',
option:'IN',
values:[this.$route.query.matId],
}],
fixed:true
}
};
delete this.config.inputCondition;
}
this.init();
this.$refs.header.getlist();
}
}



// WEBPACK FOOTER //
// ./src/page/material-info-library/mat-unit.vue